export const firebaseSettings = {
  // hermes
  apiKey: 'AIzaSyDUJ9tOpwtLaTaEiHXmRc3PnBWV3YEYsX0',
  authDomain: 'dimfer-f625d.firebaseapp.com',
  projectId: 'dimfer-f625d',
  storageBucket: 'dimfer-f625d.appspot.com',
  messagingSenderId: '944521027220',
  appId: '1:944521027220:web:6a272f4afd9ba0d0f61e81',
  measurementId: 'G-14E06N6DSV',

  //CHRISTIAN
  //apiKey: 'AIzaSyAcdAdSdiUDhffwhubOCs1EAz4F2cLDuWA',
  //authDomain: 'proyectouno-719dd.firebaseapp.com',
  //projectId: 'proyectouno-719dd',
  //storageBucket: 'proyectouno-719dd.appspot.com',
  //messagingSenderId: '453242691643',
  //appId: '1:453242691643:web:7602c217cd69eff258bc1e'

  //MARCO
  //apiKey: 'AIzaSyCGg4JhtzKsxFqhrjzLENrG2LlJTBvjk04',
  //authDomain: 'dimfer-6f3f2.firebaseapp.com',
  //projectId: 'dimfer-6f3f2',
  //storageBucket: 'dimfer-6f3f2.appspot.com',
  //messagingSenderId: '655023431019',
  //appId: '1:655023431019:web:c5b044c3e81ef337e2002e',
  //measurementId: 'G-S3WSH6XTGN'
}
